import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
import { Message } from "element-ui";
const groups = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 1000,
      total: 0,
      page: 1
    },
    selectedItems: [],
    loading: true
  }),
  mutations: {
    setGroups(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedGroups(state, payload) {
      state.selectedItems = payload;
    },
    setGroupPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getGroups");
    },
    setGroupTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getGroups");
    }
  },
  actions: {
    async getGroups(store) {
      store.state.loading = true;
      var res = await axios.post("segmentation/listgroups", store.state.filter);
      store.state.loading = false;
      res.data.data.items = res.data.data.items.map(y => {
        return {
          ...y,
          show: false
        };
      });
      store.commit("setGroups", res.data.data);
      return res;
    },
    async getGroupOne(store, payload) {
      var res = await axios.post("Segmentation/GetGroup", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async deleteGroup(store, payload) {
      var res = await axios.post("segmentation/deletegroup", {
        id: payload
      });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await store.dispatch("getGroups");
      }
    }
  },
  getters: {}
};
export default groups;



// WEBPACK FOOTER //
// ./src/store/groups.js